<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="4" y="8" width="16" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
    <path d="M9 8V6.5A1.5 1.5 0 0110.5 5h3A1.5 1.5 0 0115 6.5V8" stroke="currentColor" stroke-width="1.5" />
    <path d="M8 12h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>
